$(document).ready(function(e) {			
    
    $('ul.mainMenu li a').click(function(event) {
        event.preventDefault();
        var ids = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(ids).offset().top - 50
        }, 2000);
    });
    
    $(".packg").click(function() {
        $('html, body').animate({
            scrollTop: $("#select_pkg").offset().top - 50
        }, 2000);
    });


    $('.review_slide_row').slick({
        dots: true,
        slidesToShow:4,
        slidesToScroll: 1,
        adaptiveHeight: false,
        variableWidth: false,
        centerMode: false,
        arrows:true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1021,
                settings: {
                slidesToShow:3,
            }
            },
            
            {
                breakpoint: 767,
                settings: "unslick"
            },
        ] 
    });

    //accordion JS 
    $(".acdn-heading").click(function() {
        
        var questionDiv = $(this);
        var answerDiv   = $(this).next('.acdn-content');
        var idx = $('.acdn-content').index(answerDiv);
        
        $('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
                $(ansDiv).slideUp(500, function() {
                    $(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
                });
            }
        });
                    
        if (answerDiv.is(':visible')) {
            answerDiv.stop().slideUp(500, function() {
                questionDiv.removeClass('accordion-open');
            });
        } else {
        questionDiv.addClass('accordion-open');
        answerDiv.stop().slideDown(500);
        }
        
    });
    
    var video = $('#myVdo video')[0];
    
    $('.ugc1').click(function(e) {
        $('.ugc-modal').addClass('active');
        $('.video-container').show();
        
        var videoFile = $(this).attr('data-vdo');
        video.src = videoFile;
        video.load();
        video.play();
    });	
    
    $('.ugc-close, .ugc-modal').click(function(e) {
        video.src = '';
        $('.ugc-modal').removeClass('active');
        $('.video-container').hide();
    });
    
    
});


$(document).scroll(function() {
            
    if ($(this).scrollTop() > 40){
        $('.top-fix-bar').addClass('fixed-nav');
    }else{
        $('.top-fix-bar').removeClass('fixed-nav');
    }
    
});